import DialogProduct from './DialogProduct';

export default DialogProduct;
